import { render } from "./ButtonIcon.vue?vue&type=template&id=f6ee8092&scoped=true"
import script from "./ButtonIcon.vue?vue&type=script&lang=js"
export * from "./ButtonIcon.vue?vue&type=script&lang=js"

import "./ButtonIcon.vue?vue&type=style&index=0&id=f6ee8092&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6ee8092"]])

export default __exports__